import { Routes, Route } from 'react-router-dom';
import './styles/theme-system.css';
import ThemeSwitcher from './components/ThemeSwitcher';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/Scroll';
import WelcomeCard from './components/WelcomeCard';
import SanjayAssistant from './components/SanjayAssistant';
import './App.css';

// Public pages
import HomePage from './pages/HomePage';
import FeesPage from './pages/FeesPage';
import NotesPage from './pages/NotesPage';
import AboutPage from './pages/AboutPage';
import CoursesPage from './pages/CoursesPage';
import Contact from './pages/Contact';

// Admin shell
// import AdminLayout from './components/Admin/AdminLayout';
// import ProtectedRoute from './components/Admin/ProtectedRoute';

// Admin pages
// import AdminLogin from './pages/Admin/AdminLogin';
// import ChangePassword from './pages/Admin/ChangePassword';
// import AdminDashboard from './pages/Admin/AdminDashboard';
// import StudentsManager from './pages/Admin/StudentsManager';
// import NotesManager from './pages/Admin/NotesManager';
// import FeesManager from './pages/Admin/FeesManager';
// import NoticeBoard from './pages/Admin/NoticeBoard';
// import FeedbackManager from './pages/Admin/FeedbackManager';
// import AboutManager from './pages/Admin/AboutManager';

function App() {
  return (
    <div className="app">
      <ScrollToTop />
      <WelcomeCard />
      <SanjayAssistant />
      <Routes>
        {/* Public routes */}
        <Route
          path="/"
          element={
            <><Navbar /><ThemeSwitcher /><main className="main-content"><HomePage /></main><Footer /></>
          }
        />
        <Route path="/contact" element={<><Navbar /><ThemeSwitcher /><Contact /><Footer /></>} />
        <Route path="/fees"    element={<><Navbar /><ThemeSwitcher /><FeesPage /><Footer /></>} />
        <Route path="/notes"   element={<><Navbar /><ThemeSwitcher /><NotesPage /><Footer /></>} />
        <Route path="/about"   element={<><Navbar /><ThemeSwitcher /><AboutPage /><Footer /></>} />
        <Route path="/courses" element={<><Navbar /><ThemeSwitcher /><CoursesPage /><Footer /></>} />

        {/* Admin routes — commented out
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/change-password"
          element={<ProtectedRoute><ChangePassword /></ProtectedRoute>}
        />
        <Route
          path="/admin"
          element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="students"  element={<StudentsManager />} />
          <Route path="notes"     element={<NotesManager />} />
          <Route path="fees"      element={<FeesManager />} />
          <Route path="notices"   element={<NoticeBoard />} />
          <Route path="feedback"  element={<FeedbackManager />} />
          <Route path="about"     element={<AboutManager />} />
        </Route>
        */}
      </Routes>
    </div>
  );
}

export default App;
